import _ from 'underscore';
import Backbone from 'backbone';
import $ from 'jquery';
import uuidv4 from 'uuid/v4'; 

import Config from '../config';

import Channel from '../utils/channel';
import Comment from '../model/comment';
import { Comments } from '../collection/comments';
import CommentsLive from '../service/comments';
import Gallery from './gallery';
import Photos from '../collection/photos';
import Task from '../model/task';
import View from './view';

import { Insert } from '../service/live';
import { promisify, requestify } from '../utils/promisify';

export default View.extend( {

    initialize(options = {}) {
        View.prototype.initialize.call( this, options );

        // files are common for all observable tasks
        this.filesChannel = Channel.fromEvents( this, 'file:sent' );
    },

    onBind(model) {
        this.needRecalcUnread_ = false;
        if (model.comments_)
            onLoadComments.call( this );
        else
            // todo listenToOnce
            model.once( 'comments:load', () => { 
                onLoadComments.call( this ); 
                this.render();
            } );

        this.listenTo( model, 'comments:unread-incoming',
            () => recalcUnreadMessagesCount.call( this ) );
        
        this.listenTo( this, 'feed:position', value =>
            localStorage[`talitrum.feed.position.${Config.userId()}.${model.id}`] = value );

        // todo Channel.merge
        this.commentsChannel = CommentsLive
            .filter( message => message instanceof Insert )
            .filter( message => message.model.task_id === +model.id || message.model.news_id === +model.id )
            .map( message => new Comment( message.model ) ) // model === attrs of Model
            .merge( Channel.fromEvents( this, 'comment:sent' ) );
    },

    onUnBind(previousModel) {
        this.stopListening( this, 'feed:position' ); 
        if (this.commentsChannel)
            this.commentsChannel.close();
        if (previousModel)
            previousModel.off( 'comments:load' ),
            this.stopListening( previousModel );
    },

    serialize() {
        if (!this.model)
            return {};

        const { left, right, top, bottom } = this.options;
        const { commentsChannel, filesChannel } = this;
        const { attach_photo_video_from_camera, attach_photo_video_from_gallery } = this.model.capabilities_;

        return {
            allowAttachPhotoVideo: attach_photo_video_from_camera && attach_photo_video_from_gallery,
            left, right, top, bottom,
            commentsChannel, filesChannel,
            undock: this.top_ !== undefined, feedPosition: this.top_,
            collection: this.model.comments_ && this.model.comments_ instanceof Array
                ? new Comments( this.model.comments_ )
                : null
        }
    },

    afterRender() {
        if (!this.needRecalcUnread_)
            return;

        this.needRecalcUnread_ = false;
        repositionTopAfterLoadComments.call( this );
        scrollFeed.call( this );
    },

    events: {

        'wheel .feed-scroll-container'(e) {
            return e.stopPropagation(), e.preventDefault(),
                scrollFeed.call( this, e.originalEvent.deltaY ), 
                false;
        },

        'scroll .feed-scroll-container'(e) {
            return e.stopPropagation(), e.preventDefault(), false;
        },

        'touchmove .feed-scroll-container'(e) {
            return e.stopPropagation(), e.preventDefault(), false;
        },

        'click .comment-list--unread-counter'() {
            return scrollFeed.call( this, 1000000000 ), false;
        },

    },

    // todo: ajax-helpers
    // todo: support apiVersion=1.3 (parsing error messages)
    // todo: handle reject
    [View.event( 'Form:send' )](text, replyTo, filePromise) {
        if (filePromise)
            return this.trigger( 'file:sent', 
                filePromise.then( file => attach( this.model.id, text, file ) ) );

        const uuid = uuidv4();

        this.trigger( 'comment:sent', new Comment( { 
            uuid,
            user_id: +Config.userId(),
            fio: Config.user(),
            type: 1,
            date: new Date(),
            task_id: +this.model.id,
            comment: text,
            parent: replyTo ? replyTo.toJSON() : undefined,
        } ) ); 

        post( this.model.id, text, uuid, replyTo ? replyTo.id : null );
    },

    [View.event( 'List:gallery:open' )](activePhotoId) {
        openGallery( this.model, activePhotoId );
    },
    
    [View.event( 'List:list-modified' )]() {
        return showScrollBar.call( this );
    },
    
    [View.event( 'List:reply:begin' )](replyTo) {
        this.Form.trigger( 'reply:begin', replyTo );
    },

} );

function post(taskId, comment, uuid, parentId) {
    const url = Config.url( `news/${taskId}/comments${parentId ? '/' + parentId : ''}` ),
        message = {
            // pass action for MapAdmin-compatibility
            action: 'post',
            uuid,
            comment
        };

    const request = Backbone.ajax( {
        url, 
        contentType: 'application/json; charset=UTF-8',
        data: JSON.stringify( message ),
        method: 'post'
    } );

    return promisify( request );
}

function attach(taskId, comment, { name, type, originalName }) {
    let fileType;
    switch (type) {
        case 'photos': fileType = 'PHOTO'; break;
        case 'files': fileType = 'FILE'; break;
        case 'videos': fileType = 'VIDEO'; break;
        case 'sounds': fileType = 'SOUND'; break;
    }

    const attachments = [{ 
        file: name, 
        file_name: originalName,
        file_type: fileType
    }];

    return new Task( { id: taskId } )
        .patch( { attachments, update_comments: comment } )
        .then( () => ({ 
            date: new Date(),
            name: originalName,
            type: fileType
        }) );
}

function openGallery(task, activePhotoId) {
    const photos = new Photos( {
        endpoint: `news/${task.id}/photos?apiVersion=1.4`
    } );

    // todo: multiple openGallery.clicks
    requestify( photos.fetch() )
        .then( ({ array }) => {
            const urls = array
                .map( photo => `/news/${task.id}/photos/${photo.num}` )
                .map( url => Config.url( url ) );

            let activePhotoIndex;
            array.forEach( (photo, index) => {
                if (+photo.id === +activePhotoId)
                    activePhotoIndex = index;
            } );
            
            return Gallery.open( urls, activePhotoIndex );
        } );
}

function scrollFeed(deltaY = 0) {
    const listHeight = verticalSpace.call( this );
    const contHeight = visibleSpace.call( this );

    const minTop = -listHeight + contHeight;
    let top = this.top_ !== undefined
        ? this.top_
        : minTop;

    const prevTop = this.top_;
    top = Math.max( Math.min( top - deltaY, 0 ), minTop );
    if (top < minTop + 1e-6) top = undefined;

    const needDock = top === undefined;
    const needUndock = prevTop === undefined && top !== undefined;

    const $el = this.$( '.feed-scroll-container' );

    if (needUndock) {
        $el.off( 'transitionend', handleTransitionEnd );
        $el.css( 'bottom', 'auto' ).css( 'top', `${minTop}px` );
        setTimeout( () => $el.css( 'top', `${top}px` ), 0 );
        this.trigger( 'feed:position', top );
    } else if (needDock) {
        if (prevTop !== undefined) {
            $el.off( 'transitionend', handleTransitionEnd );
            $el.on( 'transitionend', handleTransitionEnd );
            $el.css( 'top', `${minTop}px` );
            this.trigger( 'feed:position', null );
        }
    } else {
        $el.css( 'top', `${top}px` );
        this.trigger( 'feed:position', top );
    }

    this.top_ = top;

    showScrollBar.call( this );
    recalcUnreadMessagesCount.call( this );
}

function handleTransitionEnd(/*e*/) {
    const $el = $( this );
    $el.off( 'transitionend', handleTransitionEnd );
    $el.css( 'top', 'auto' ).css( 'bottom', '0' );
}

function showScrollBar() {
    const scrollHeight = visibleSpace.call( this ) / verticalSpace.call( this ) * visibleSpace.call( this );
    if (scrollHeight > visibleSpace.call( this ))
        return this.$( '.feed-scroll' ).css( 'display', 'none' );

    let bottom;
    if (this.top_ === undefined)
        bottom = 0;
    else {
        const minTop = visibleSpace.call( this ) - verticalSpace.call( this );
        const ratio = (minTop - this.top_) / minTop;
        bottom = (visibleSpace.call( this ) - scrollHeight) * ratio;
    }

    this.$( '.feed-scroll' ).css( {
        display: 'block',
        height: `${scrollHeight}px`,
        bottom: `${bottom}px`
    } );

    this.$( '.feed-scroll' ).removeClass( '__fade-out-after-3000' );
    setTimeout( () => this.$( '.feed-scroll' ).addClass( '__fade-out-after-3000' ), 0 );
}

function verticalSpace() {
    return this.List.$el.height();
}

function visibleSpace() {
    // todo via class
    return this.$( '.feed-scroll-container' ).parent().height();
}

function onLoadComments() {
    this.needRecalcUnread_ = true;
    
    const feedPosition = localStorage[`talitrum.feed.position.${Config.userId()}.${this.model.id}`];
    this.top_ = feedPosition === 'null' || feedPosition === undefined
        ? undefined
        : parseFloat( feedPosition );
}

function repositionTopAfterLoadComments() {
    const unread = this.model.get( 'unread_message_count' );
    if (unread == null || +unread === 0)
        return;

    if (this.top_ != undefined)
        return;

    if (+unread <= 5)
        return;

    const $lastEl = this.$( '.comment--wrapper' )
        .eq( this.model.comments_.length - unread + 5 );

    const { top: elTop } = $lastEl.position();
    const newTop = visibleSpace.call( this ) - elTop;

    if (newTop < 0)
        this.top_ = newTop,
        this.$( '.feed-scroll-container' )
            .css( 'top', `${newTop}px` )
            .css( 'bottom', 'auto' );
}

const recalcUnreadMessagesCount = _.debounce( function() {
    let unread = this.model.get( 'unread_message_count' );
    if (unread === null)
        return;

    let lastRead = this.model.comments_[0];
    if (this.top_ === undefined)
        return this.model.set( 'unread_message_count', 0 ), // todo null
            this.trigger( 'comments:recalc-unread', this.model ),
            $.post( Config.url( `/chats/${lastRead.chat_id}/messages/${lastRead.chat_message_number}/read` ) );

    const bottomLine = -this.top_ + visibleSpace.call( this );

    const $comments = this.$( '.comments-list--item' );
    let i = $comments.length - unread; while (i < $comments.length)
        if ($comments.eq( i ).position().top + $comments.eq( i ).height() <= bottomLine)
            i++;
        else
            break;

    const delta = i - $comments.length + unread;
    lastRead = i > 0 && this.model.comments_[this.model.comments_.length - i];
    if (delta > 0)
        this.model.set( 'unread_message_count', unread - delta ),
        this.trigger( 'comments:recalc-unread', this.model ),
        console.log( lastRead ),
        lastRead && $.post( Config.url( `/chats/${lastRead.chat_id}/messages/${lastRead.chat_message_number}/read` ) );
}, 250 );


// WEBPACK FOOTER //
// ./src/js/view/comment.feed.js